import { render, staticRenderFns } from "./InstantWebsite.vue?vue&type=template&id=c86ad622"
import script from "./InstantWebsite.vue?vue&type=script&lang=js"
export * from "./InstantWebsite.vue?vue&type=script&lang=js"
import style0 from "./InstantWebsite.vue?vue&type=style&index=0&id=c86ad622&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports